import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-alphabet-selector',
  templateUrl: './alphabet-selector.component.html',
  styleUrls: ['./alphabet-selector.component.scss']
})
export class AlphabetSelectorComponent {
  alpha = Array.from(Array(26)).map((e, i) => i + 65);
  alphabet = this.buildAlphabetArray()

  @Input() selectedCharacter = 'a'
  @Input() availableChars: string[] | null = [];
  @Input() displayUnavailableChars: boolean = true;

  @Output() characterSelected = new EventEmitter<string>();

  public characterSelectionHandler(character: string): void {
    this.characterSelected.emit(character)
    this.selectedCharacter = character
  }

  buildAlphabetArray() {
    return this.alpha.map((x) => String.fromCharCode(x));
  }
}
